import { render, staticRenderFns } from "./GoObjects.vue?vue&type=template&id=0a6604d8"
import script from "./GoObjects.vue?vue&type=script&lang=js"
export * from "./GoObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports